export const data = {
    name: "History",
    layout: [],
};
export default data;